import { Box, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";

const TransactionValue = ({ date, transactionType, amount, fee }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "16px",
        justifyContent: "space-between",
      }}
    >
      <Typography
        sx={{ fontWeight: "700", fontSize: "14px", color: "#043964" }}
      >
        {moment(date)
          .utcOffset("+0800")
          .format("DD MMM YYYY")}
      </Typography>
      <Typography
        sx={{
          fontWeight: "700",
          lineHeight: 1.5,
          color:
            transactionType === "Buy" ||
            transactionType === "ManBuy" ||
            transactionType === "RSPBuy" ||
            transactionType === "TransferIn" ||
            transactionType === "SwitchIn"
              ? "#18a29a"
              : transactionType === "Dividend"
              ? "#1278CC"
              : "#333",
        }}
      >
        {transactionType === "Buy" ||
        transactionType === "ManBuy" ||
        transactionType === "Dividend" ||
        transactionType === "ManBuy" ||
        transactionType === "Bonus" ||
        transactionType === "RSPBuy" ||
        transactionType === "TransferIn" ||
        transactionType === "SwitchIn"
          ? "+"
          : "-"}
        RM{" "}
        <NumberFormat
          value={
            transactionType === "ManBuy" ||
            transactionType === "RSPBuy" ||
            transactionType === "TransferIn" ||
            transactionType === "SwitchIn"
              ? amount + fee
              : transactionType === "Dividend" || transactionType === "Buy"
              ? amount
              : amount - fee
          }
          thousandSeparator
          displayType="text"
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </Typography>
    </Box>
  );
};

export default TransactionValue;
